import React from "react";
import { MdOutlineMap } from "react-icons/md";

// Vendor state-wise charges (e.g. Green Tax): flat (minimum + per kg) or slab based.
// In edit mode every rate / minimum is an input; edited values are highlighted and keep the
// current MV Load value next to them (same behaviour as the other charges).
const StateCharges = ({ stateCharges = [], editable, draft = {}, onChange }) => {
  if (!stateCharges.length) return null;

  const cell = (key, current, text) => {
    if (!editable) return text;
    const edited = draft[key] !== undefined;
    const changed = edited && String(draft[key]) !== String(current);
    return (
      <>
        <input
          className={changed ? "changed" : ""}
          inputMode="decimal"
          value={edited ? draft[key] : current}
          onChange={(e) => onChange(key, e.target.value.replace(/[^\d.]/g, ""))}
        />
        {changed && <small className="was">was {current}</small>}
      </>
    );
  };
  const box = (label, value) => (
    <div className="slab_box">
      <span className="slab_label">{label}</span>
      <span className="slab_value">{value}</span>
    </div>
  );

  return (
    <div className="ob_surcharges">
      <h5 className="ob_section_title">
        <MdOutlineMap /> State Charges
      </h5>
      <div className="ob_charge_group">
        <div className="ob_tiles">
          {stateCharges.map((sc) =>
            sc.rateMode === "slab" ? (
              <div key={sc.id} className="ob_tile slab">
                <div className="top">
                  <strong>
                    {sc.chargeName} · {sc.stateName}
                  </strong>
                  <span className="mode_tag flat">{sc.type}</span>
                </div>
                <p>Rate and minimum by weight slab</p>
                {sc.slabs.map((slab) => (
                  <div key={slab.id} className="slab_row">
                    {box("From", slab.from)}
                    {box("To", slab.to)}
                    {box("UNIT", slab.unit)}
                    {box("₹", cell(`sc:${sc.id}:slab:${slab.id}:amount`, slab.amount, slab.amount.toFixed(2)))}
                    {box("Min", cell(`sc:${sc.id}:slab:${slab.id}:minValue`, slab.minValue, slab.minValue.toFixed(2)))}
                  </div>
                ))}
              </div>
            ) : (
              <div key={sc.id} className="ob_tile">
                <div className="top">
                  <strong>
                    {sc.chargeName} · {sc.stateName}
                  </strong>
                  <span className="mode_tag flat">{sc.type}</span>
                </div>
                <p>Greater of the minimum or weight × rate</p>
                <div className="ob_fields">
                  <div className="field">
                    <label>Minimum</label>
                    <div className="val readonly">{cell(`sc:${sc.id}:amount`, sc.amount, `₹${sc.amount}`)}</div>
                  </div>
                  <div className="field">
                    <label>Per kg</label>
                    <div className="val readonly">{cell(`sc:${sc.id}:perKgAmount`, sc.perKgAmount, `₹${sc.perKgAmount} /kg`)}</div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default StateCharges;
